import { Switch } from 'antd';
import styled from 'styled-components';

export const CustomSwitch = styled(Switch)`
  &.ant-switch-checked {
    background-color: var(--primary-color) !important;
  }
`;
